// extracted by mini-css-extract-plugin
module.exports = {"tabsContainer":"Contacts_tabsContainer__3PZvy","tab":"Contacts_tab__19Tou","tabActive":"Contacts_tabActive__BrFxG","userCounter":"Contacts_userCounter__1sjSs"};